export const setReportHeight = barCount => {
  if (barCount === 1) return 160;
  else if (barCount === 2) return 220;
  else if (barCount > 2 && barCount < 10) return barCount * 80;
  else return barCount * 40;
};
